"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSortableHeaderFormatter = exports.ArrowIcon = exports.SortableHeaderFormatter = exports.measureWidth = exports.textHeaderStyle = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var ReactDOM = require("react-dom");
var NarrowSortArrowAscending_1 = require("../../../../gen-src/icons/NarrowSortArrowAscending");
var NarrowSortArrowDescending_1 = require("../../../../gen-src/icons/NarrowSortArrowDescending");
var globalTypes_1 = require("../../../../gen-src/queries/globalTypes");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var LayoutStyles_1 = require("../../style/LayoutStyles");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
exports.textHeaderStyle = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    fontWeight: 'bold',
    color: widgets_1.TabStyles.Typography.Color.PrimaryLight,
    paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    paddingRight: widgets_1.TabStyles.Spacing.MediumSpace,
};
// Shamelessly copied from datagrid code
function measureWidth(componentOrElement) {
    // eslint-disable-next-line react/no-find-dom-node
    var domNode = ReactDOM.findDOMNode(componentOrElement);
    var rect = domNode.getBoundingClientRect();
    return Math.ceil(rect.right - rect.left);
}
exports.measureWidth = measureWidth;
var SortableHeaderCellContainer = LayoutComponents_1.divWithStyle('SortableHeaderCellContainer', __assign(__assign(__assign(__assign({}, LayoutStyles_1.elideTextStyle), VizPortalStyles_1.vizPortalFontStyle), exports.textHeaderStyle), { paddingLeft: 0, boxSizing: 'border-box' }));
var SortableHeaderCellText = LayoutComponents_1.divWithStyle('SortableHeaderCellText', __assign(__assign({}, LayoutStyles_1.elideTextStyle), { flex: '1 1 auto' }));
/**
 * A header formatter that displays the column text and also an arrow showing the currently-applied sort order
 */
var SortableHeaderFormatter = /** @class */ (function (_super) {
    __extends(SortableHeaderFormatter, _super);
    function SortableHeaderFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasReportedWidth = false;
        _this.handleClickOrTap = function () {
            if (_this.props.col.sortable && _this.props.changeSort) {
                _this.props.changeSort(_this.props.col.dataKey);
            }
        };
        return _this;
    }
    SortableHeaderFormatter.prototype.render = function () {
        var col = this.props.col;
        var isSortable = col.sortable === true;
        var extraContainerStyles = {
            textAlign: this.props.textAlign ? this.props.textAlign : undefined,
            textDecoration: isSortable && this.props.hovered ? 'underline' : 'none',
            color: this.isSorted ? widgets_1.TabStyles.Typography.Color.PrimaryDark : widgets_1.TabStyles.Typography.Color.PrimaryLight,
        };
        // VizPortal has support for sort orders that are "directionless" (e.g. relevance, which can be only descending).
        // We may eventually support that too, but currently all our sorts have two directions.
        var supportsDirections = true;
        return (React.createElement(SortableHeaderCellContainer, { style: extraContainerStyles, onClick: this.handleClickOrTap, onTouchStart: this.handleClickOrTap, "data-tb-test-id": "display-grid-header-" + this.props.col.dataKey },
            React.createElement(ArrowIcon, { sorted: this.isSorted, ascending: this.ascending, supportsAscDesc: supportsDirections }),
            React.createElement(SortableHeaderCellText, null, col.headerText)));
    };
    SortableHeaderFormatter.prototype.componentDidMount = function () {
        // getBoundingClientRect doesnt play nice with overflow: 'hidden' property.
        // so measure width of header and add a 6 pixel padding
        // to ensure we don't elide header column text on initial render
        if (!this.hasReportedWidth && this.props.reportWidthFn) {
            this.hasReportedWidth = true;
            this.props.reportWidthFn(this.props.col.name, measureWidth(this) + 6);
        }
    };
    Object.defineProperty(SortableHeaderFormatter.prototype, "isSorted", {
        get: function () {
            return this.props.currentSort ? (this.props.currentSort.field.toLowerCase() === this.props.col.dataKey.toLowerCase()) : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortableHeaderFormatter.prototype, "ascending", {
        get: function () {
            return this.props.currentSort ? (this.props.currentSort.direction.toLowerCase() === globalTypes_1.OrderDirection.ASC.toLowerCase()) : false;
        },
        enumerable: false,
        configurable: true
    });
    return SortableHeaderFormatter;
}(React.Component));
exports.SortableHeaderFormatter = SortableHeaderFormatter;
// arrow takes up left padding of hcell
var arrowWidth = widgets_1.TabStyles.Spacing.MediumSpace;
var arrowHeight = 19;
function ArrowIcon(props) {
    var arrowImg = getArrowImg(props);
    var arrowStyles = {
        width: arrowWidth,
        height: arrowHeight,
        display: 'inline-block',
        verticalAlign: 'middle',
    };
    return React.createElement("div", { style: arrowStyles }, arrowImg);
}
exports.ArrowIcon = ArrowIcon;
function getArrowImg(props) {
    if (props.sorted && props.supportsAscDesc) {
        if (props.ascending) {
            return React.createElement(NarrowSortArrowAscending_1.SvgNarrowSortArrowAscending, { height: arrowHeight });
        }
        else {
            return React.createElement(NarrowSortArrowDescending_1.SvgNarrowSortArrowDescending, { height: arrowHeight });
        }
    }
    else {
        return null;
    }
}
/**
 * Creates a "text header formatter" for grids whose columns could be sortable.
 * The sortable functionality will be enabled only if the column has `sortable: true`,
 * otherwise it will behave like a normal unsortable text header formatter.
 *
 * So, this "sortable" header formatter CAN be used for unsortable columns (it is preferred to do so,
 * because then sortability can be toggled simply by changing a boolean).
 */
function createSortableHeaderFormatter(gridSortProps, textAlign) {
    // eslint-disable-next-line react/display-name
    return function (props) { return (React.createElement(SortableHeaderFormatter, __assign({}, props, { currentSort: gridSortProps.orderBy, changeSort: gridSortProps.updateSortOrder, textAlign: textAlign }))); };
}
exports.createSortableHeaderFormatter = createSortableHeaderFormatter;
//# sourceMappingURL=SortableHeaderFormatter.js.map